import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { id: "closet-wardrobe" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "page-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "title" }, "나의 옷장"),
  /*#__PURE__*/_createElementVNode("div", { class: "subtitle" }, "브랜드·모델별 사이즈와 핏을 기록해 다음 구매 때 바로 참고하세요")
], -1)
const _hoisted_3 = { class: "wardrobe-header" }
const _hoisted_4 = { class: "category-tabs" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "search-bar" }
const _hoisted_7 = { class: "wardrobe-body" }
const _hoisted_8 = { class: "list-section" }
const _hoisted_9 = {
  key: 0,
  class: "list-info"
}
const _hoisted_10 = { class: "list-count" }
const _hoisted_11 = {
  key: 1,
  class: "clothing-card-list"
}
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "cc-top" }
const _hoisted_14 = { class: "badge category sm" }
const _hoisted_15 = { class: "cc-brand" }
const _hoisted_16 = {
  key: 0,
  class: "cc-stars"
}
const _hoisted_17 = {
  key: 0,
  class: "cc-product"
}
const _hoisted_18 = { class: "cc-sizerow" }
const _hoisted_19 = {
  key: 0,
  class: "cc-size"
}
const _hoisted_20 = {
  key: 2,
  class: "cc-nosize"
}
const _hoisted_21 = {
  key: 1,
  class: "card-measures"
}
const _hoisted_22 = {
  key: 2,
  class: "empty-message"
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "empty-icon" }, "👚", -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("p", null, "등록된 의류가 없습니다", -1)
const _hoisted_25 = { class: "fit-reco-panel" }
const _hoisted_26 = { class: "reco-head" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "reco-title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "reco-icon" }, "📏"),
  /*#__PURE__*/_createTextVNode(" 내게 맞는 사이즈 ")
], -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("span", { class: "sep" }, "/", -1)
const _hoisted_29 = { class: "reco-cat-label" }
const _hoisted_30 = {
  key: 0,
  class: "reco-rows"
}
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "reco-section-label" }, "공통 부위", -1)
const _hoisted_32 = { class: "reco-part" }
const _hoisted_33 = {
  key: 0,
  class: "reco-val"
}
const _hoisted_34 = {
  key: 1,
  class: "reco-val muted"
}
const _hoisted_35 = { class: "reco-basis" }
const _hoisted_36 = { class: "reco-section-label" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("span", { class: "sub" }, "소분류별", -1)
const _hoisted_38 = { class: "reco-part" }
const _hoisted_39 = { class: "reco-val" }
const _hoisted_40 = { class: "reco-basis" }
const _hoisted_41 = {
  key: 1,
  class: "reco-empty"
}
const _hoisted_42 = /*#__PURE__*/_createElementVNode("p", null, "핏 평가가 입력된 옷이 아직 없어요.", -1)
const _hoisted_43 = /*#__PURE__*/_createElementVNode("p", { class: "hint" }, [
  /*#__PURE__*/_createTextVNode("옷을 등록할 때 "),
  /*#__PURE__*/_createElementVNode("b", null, "핏 평가"),
  /*#__PURE__*/_createTextVNode("(작음/딱맞음/큼)를 함께 남기면"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("부위별로 내게 맞는 수치를 계산해 드려요.")
], -1)
const _hoisted_44 = [
  _hoisted_42,
  _hoisted_43
]
const _hoisted_45 = {
  key: 2,
  class: "reco-foot"
}
const _hoisted_46 = {
  key: 0,
  class: "summary-section"
}
const _hoisted_47 = /*#__PURE__*/_createElementVNode("div", { class: "summary-title" }, "브랜드별 사이즈 요약", -1)
const _hoisted_48 = { class: "summary-list" }
const _hoisted_49 = { class: "brand-name" }
const _hoisted_50 = { class: "brand-count" }
const _hoisted_51 = { class: "brand-items" }
const _hoisted_52 = { class: "badge category sm" }
const _hoisted_53 = { class: "item-size" }
const _hoisted_54 = {
  key: 0,
  class: "item-stars"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categoryTabs, (tab) => {
          return (_openBlock(), _createElementBlock("button", {
            key: tab.value,
            class: _normalizeClass(["tab-btn", { active: _ctx.search.category === tab.value }]),
            onClick: ($event: any) => (_ctx.selectCategory(tab.value))
          }, _toDisplayString(tab.label), 11, _hoisted_5))
        }), 128))
      ]),
      _createElementVNode("button", {
        class: "btn-register",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goToRegister && _ctx.goToRegister(...args)))
      }, "+ 등록")
    ]),
    _createElementVNode("div", _hoisted_6, [
      _withDirectives(_createElementVNode("input", {
        type: "text",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.search.keyword) = $event)),
        placeholder: "브랜드명, 소분류 검색",
        onKeyup: _cache[2] || (_cache[2] = _withKeys(
//@ts-ignore
(...args) => (_ctx.fetchClothingList && _ctx.fetchClothingList(...args)), ["enter"]))
      }, null, 544), [
        [_vModelText, _ctx.search.keyword]
      ]),
      _createElementVNode("button", {
        class: "btn-search",
        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.fetchClothingList && _ctx.fetchClothingList(...args)))
      }, "검색"),
      (_ctx.hasSearchFilter)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "btn-reset",
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.resetSearch && _ctx.resetSearch(...args)))
          }, "초기화"))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        (_ctx.clothingList.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.clothingList.length) + "건", 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.clothingList.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.clothingList, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "clothing-card",
                  key: item.id,
                  onClick: ($event: any) => (_ctx.goToDetail(item.id))
                }, [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.getCategoryLabel(item.category)), 1),
                    _createElementVNode("span", _hoisted_15, _toDisplayString(item.brandName || '브랜드 미입력'), 1),
                    (item.satisfaction)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_16, [
                          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (s) => {
                            return _createElementVNode("span", {
                              key: s,
                              class: _normalizeClass(["star-sm", { active: s <= item.satisfaction }])
                            }, "★", 2)
                          }), 64))
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  (item.productName || item.subCategory)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(item.productName || item.subCategory), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_18, [
                    (item.labeledSize)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(item.labeledSize), 1))
                      : _createCommentVNode("", true),
                    (item.fitFeedback)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 1,
                          class: _normalizeClass(["fit-chip", _ctx.fitClass(item.fitFeedback)])
                        }, _toDisplayString(_ctx.getFitFeedbackLabel(item.fitFeedback)), 3))
                      : _createCommentVNode("", true),
                    (!item.labeledSize && !item.fitFeedback)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_20, "사이즈·핏 미기록"))
                      : _createCommentVNode("", true)
                  ]),
                  (item.measurements && Object.keys(item.measurements).length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.measurements, (val, key) => {
                          return (_openBlock(), _createElementBlock("span", {
                            key: key,
                            class: "measure-tag"
                          }, _toDisplayString(_ctx.getMeasureLabel(item.category, String(key))) + " " + _toDisplayString(_ctx.formatMeasure(Number(val), _ctx.getUnit(item.category, String(key)), _ctx.toInch)), 1))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ], 8, _hoisted_12))
              }), 128))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_22, [
              _hoisted_23,
              _hoisted_24,
              _createElementVNode("button", {
                class: "btn-primary",
                onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.goToRegister && _ctx.goToRegister(...args)))
              }, "첫 의류 등록하기")
            ]))
      ]),
      _createElementVNode("aside", _hoisted_25, [
        _createElementVNode("div", _hoisted_26, [
          _hoisted_27,
          _createElementVNode("button", {
            class: "unit-toggle",
            onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.toggleUnit && _ctx.toggleUnit(...args)))
          }, [
            _createElementVNode("span", {
              class: _normalizeClass({ on: !_ctx.toInch })
            }, "cm", 2),
            _hoisted_28,
            _createElementVNode("span", {
              class: _normalizeClass({ on: _ctx.toInch })
            }, "in", 2)
          ])
        ]),
        _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.getCategoryLabel(_ctx.recoCategory)), 1),
        (_ctx.hasRecoData)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (_ctx.fitReco.common.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                    _hoisted_31,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fitReco.common, (row) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: _normalizeClass(["reco-row", { empty: row.recommended == null }]),
                        key: row.key
                      }, [
                        _createElementVNode("span", _hoisted_32, _toDisplayString(row.label), 1),
                        (row.recommended != null)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_33, [
                              _createTextVNode(_toDisplayString(_ctx.convertMeasure(row.recommended, row.unit, _ctx.toInch)), 1),
                              _createElementVNode("em", null, _toDisplayString(_ctx.displayUnit(row.unit, _ctx.toInch)), 1)
                            ]))
                          : (_openBlock(), _createElementBlock("span", _hoisted_34, "–")),
                        _createElementVNode("span", _hoisted_35, _toDisplayString(_ctx.recoDetail(row)), 1)
                      ], 2))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fitReco.lengthGroups, (g) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "reco-rows length",
                  key: g.key
                }, [
                  _createElementVNode("div", _hoisted_36, [
                    _createTextVNode(_toDisplayString(g.label) + " ", 1),
                    _hoisted_37
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(g.items, (it) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "reco-row",
                      key: it.subCategory
                    }, [
                      _createElementVNode("span", _hoisted_38, _toDisplayString(it.subCategory), 1),
                      _createElementVNode("span", _hoisted_39, [
                        _createTextVNode(_toDisplayString(_ctx.convertMeasure(it.row.recommended, g.unit, _ctx.toInch)), 1),
                        _createElementVNode("em", null, _toDisplayString(_ctx.displayUnit(g.unit, _ctx.toInch)), 1)
                      ]),
                      _createElementVNode("span", _hoisted_40, _toDisplayString(_ctx.recoDetail(it.row)), 1)
                    ]))
                  }), 128))
                ]))
              }), 128))
            ], 64))
          : (_openBlock(), _createElementBlock("div", _hoisted_41, _hoisted_44)),
        (_ctx.hasRecoData)
          ? (_openBlock(), _createElementBlock("div", _hoisted_45, " 같은 카테고리 옷들의 실측치와 핏 평가를 비교해 추정한 값이에요. "))
          : _createCommentVNode("", true)
      ])
    ]),
    (_ctx.brandSummary.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
          _hoisted_47,
          _createElementVNode("div", _hoisted_48, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groupedBrandSummary, (items, brand) => {
              return (_openBlock(), _createElementBlock("div", {
                key: brand,
                class: "summary-brand"
              }, [
                _createElementVNode("div", _hoisted_49, [
                  _createTextVNode(_toDisplayString(brand) + " ", 1),
                  _createElementVNode("span", _hoisted_50, "(" + _toDisplayString(_ctx.getTotalCount(items)) + "건)", 1)
                ]),
                _createElementVNode("div", _hoisted_51, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items, (item) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: item.category + item.labeledSize,
                      class: "brand-item"
                    }, [
                      _createElementVNode("span", _hoisted_52, _toDisplayString(_ctx.getCategoryLabel(item.category)), 1),
                      _createElementVNode("span", _hoisted_53, _toDisplayString(item.labeledSize), 1),
                      (item.avgSatisfaction)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_54, [
                            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (s) => {
                              return _createElementVNode("span", {
                                key: s,
                                class: _normalizeClass(["star-sm", { active: s <= Math.round(item.avgSatisfaction) }])
                              }, "★", 2)
                            }), 64))
                          ]))
                        : _createCommentVNode("", true),
                      (item.fitFeedback)
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 1,
                            class: _normalizeClass(["fit-chip sm", _ctx.fitClass(item.fitFeedback)])
                          }, _toDisplayString(_ctx.getFitFeedbackLabel(item.fitFeedback)), 3))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ])
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}